/* eslint-disable no-magic-numbers */
import React, { useLayoutEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { useI18nConstants } from '../../use-i18n-constants';

import styles from './tags-filter.scss';

export const TagsFilter = ({ selectedTag, onChange }: { selectedTag: string; onChange: (v: string) => void }) => {
  const tagsContainerRef = useRef<HTMLDivElement>(null);
  const { templateTags } = useI18nConstants();
  const [showShadow, setShowShadow] = useState('');

  useLayoutEffect(() => {
    const element = tagsContainerRef.current;
    let isMounted = true;

    const updateShadowPosition = () => {
      if (element && isMounted) {
        const parentWidth = element.clientWidth;
        const insideWidth = element.getElementsByTagName('div')[0]?.clientWidth;
        const diff = insideWidth - parentWidth;
        if (diff > 0) {
          const side = element.scrollLeft ? (diff - element.scrollLeft < 2 ? 'Left' : 'Both') : 'Right';
          setShowShadow(side);
        } else {
          setShowShadow('');
        }
      }
    };

    setTimeout(() => updateShadowPosition(), 100);
    window.addEventListener('resize', updateShadowPosition);
    if (element) {
      element.addEventListener('scroll', updateShadowPosition);
    }

    return () => {
      isMounted = false;
      window.removeEventListener('resize', updateShadowPosition);
      if (element) {
        element.removeEventListener('scroll', updateShadowPosition);
      }
    };
  }, []);

  return (
    <div className={classNames(styles.tagFilter, showShadow && styles[`shadow${showShadow}`])} ref={tagsContainerRef}>
      <div>
        {templateTags.map(tag => (
          <button key={tag.value} onClick={() => onChange(tag.value)} data-selected={selectedTag === tag.value}>
            {tag.name}
          </button>
        ))}
      </div>
    </div>
  );
};
